import { defineComponent as _defineComponent } from 'vue'
import router,{ routes} from "../router";
import events from "../events";
import HeaderNav from "../components/header-nav.vue";
import Version from "../components/version.vue";
import { computed, onMounted, ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props, { expose: __expose }) {
  __expose();

const year = new Date().getFullYear()
const showNavMenu = ref(true)

router.beforeEach(to=>{
    showNavMenu.value = to.meta.showMenu as boolean;
})

onMounted(() => {
    (window as any).APPLICATION_LOADER.done();
})


const __returned__ = { year, showNavMenu, get router() { return router }, get routes() { return routes }, get events() { return events }, HeaderNav, Version, computed, onMounted, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})